'use strict';

import 'angular';

var app = angular.module('brg.config.django', []);
app.config(function($httpProvider) {
	'ngInject';
	$httpProvider.defaults.xsrfCookieName = 'csrftoken';
	$httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
});
